/**
 * The ONE badge for an order's bank status, shared by the client Orders,
 * Recurring orders and Mandate orders tabs (all three use
 * `PortfolioOrderStatus`). Variant mapping and labels live here so the tabs
 * cannot drift apart again.
 */

export const T = {
  en_GB: {
    status: {
      pending: "Pending",
      submitted: "Submitted",
      executed: "Executed",
      partially_executed: "Partial",
      failed: "Failed",
      cancelled: "Cancelled",
      modified: "Modified",
    },
  },
  nb_NO: {
    status: {
      pending: "Ventende",
      submitted: "Sendt",
      executed: "Utført",
      partially_executed: "Delvis",
      failed: "Feilet",
      cancelled: "Kansellert",
      modified: "Endret",
    },
  },
} as const;
